import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@/design-system';
import { AppRoutes } from '@/app/AppRoutes';
import { ApplicantSessionProvider } from '@/lib/applicant/ApplicantSessionProvider';
import { AuthProvider } from '@/lib/auth/AuthProvider';
// The token files first, then the app layer that builds on them.
//
// Five separate imports rather than one, because global.css does not import the
// tokens — it USES them. Without these lines every custom property resolves to
// nothing and the application renders as unstyled HTML that looks like a broken
// build. An earlier build shipped that way for nine slices; tokens.test.ts now
// fails if any stylesheet under styles/ is not imported here.
import '@/styles/tokens/colors.css';
import '@/styles/tokens/typography.css';
import '@/styles/tokens/spacing.css';
import '@/styles/tokens/radii.css';
import '@/styles/tokens/shadows.css';
import '@/styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <ApplicantSessionProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ApplicantSessionProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
